"use client";

import React from "react";

const VideoBackground = () => {
  return (
    <>
      {/* Full-width video background */}
      <video
        autoPlay
        muted
        playsInline
        className="absolute top-[-90px] left-0 w-full h-full object-cover z-0"
        onLoadedData={(e) => {
          const video = e.currentTarget;
          video.playbackRate = 0.5;
        }}
      >
        <source src="/v2/animation.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Gradient overlay for text readability, from transparent to black/20 */}
      <div
        className="absolute top-0 left-0 w-full z-10 pointer-events-none"
        style={{
          background: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%)",
          height: "calc(100% - 90px)",
        }}
      />
    </>
  );
};

export default VideoBackground;
